<template>
    <div class="">
        <transition name="fade">
            <div v-if="regBox.show" class="box-container">
                <div class="box-main">
                    <div class="header clearfix">
                        <h2 v-if="!isLogin">{{regBoxData.btnText}}</h2>
                        <div v-if="isLogin" class="h-list">
                            <h2 :class="{'active':hList[0]}" @click="passwordLoginHandle">密码登录</h2>
                            <h2 :class="{'active':hList[1]}" @click="codeLoginHandle">短信登录</h2>
                        </div>
                        <i @click="regBoxCloseHandle"></i>
                    </div>
                    <div class="main">
                        <div class="m-l">
                            <div class="shh-bg"></div>
                        </div>
                        <div class="m-r">
                            <div v-if="!regBoxData.regSuccess" class="enter-contain">
                                <ul>
                                    <li>
                                        <input v-model="phone" :maxlength="11" placeholder="手机号" type="text" name="" value="">
                                    </li>
                                    <li v-if="regBoxData.isCode">
                                        <input v-model="code" :maxlength="6" placeholder="验证码" type="text" name="" value="">
                                        <button class="code" @click="getCode">{{codeMsg}}</button>
                                    </li>
                                    <li v-if="regBoxData.isPassword">
                                        <input v-model="password" :maxlength="20" placeholder="密码" type="password" name="" value="">
                                    </li>
                                </ul>
                                <div class="btn" @click="applyHandle">{{regBoxData.btnText | cpText}}</div>
                                <div class="bottom-text clearfix">
                                    <p class="info fl">{{regBoxData.infoText}}？点我<b @click="regHandle">{{regBoxData.ciText}}</b></p>
                                    <p class="fr"><i @click="forgetPwdHandle">忘记密码</i></p>
                                </div>
                            </div>
                            <div v-if="regBoxData.regSuccess" class="reg-success">
                                <h2>欢迎加入点点大家庭！</h2>
                                <p>扫描二维码下载点点APP,立即领取您的额度！</p>
                                <div class="qrcode"></div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </transition>
    </div>
</template>
<script>
    import Rsa from '../../utils/rsa'
    import api from '../../api/axios'
    import { filterData,randomString } from '../../utils/tool'
    import md5 from 'js-md5'
    export default {
        data() {
            return {
                phone: '',
                code: '',
                password: '',
                codeMsg: '获取验证码',
                isRegister: 0,
                hList: [true, false],
                isLogin: false,
                regBoxData: {
                    isCode: true,
                    regSuccess: false,
                    btnText: '',
                    infoText: '',
                    isPassword: true
                },
                reg: {
                    name: /^([\u4e00-\u9fa5 ]{0,20})$/,
                    number: /(^\d{18}$)|(^\d{17}(\d|X|x)$)/,
                    card: /^\d{4,19}$/,
                    phone: /^1\d{10}$/,
                    code: /^\d{4,6}$/,
                    pwd: /^(?![0-9]+$)(?![a-zA-Z]+$)[0-9A-Za-z]{6,20}$/
                },
                ds:60
            }
        },
        filters: {
            cpText(s) {
                let cpName = ''
                switch (s) {
                    case '找回密码':
                        cpName = '提交'
                        break;
                }
                return cpName == '' ? s : cpName
            }
        },
        props: {
            regBox: {
                type: Object,
                default: function() {
                    return {}
                }
            }
        },
        watch: {
            regBox: {
                handler: function(n, o) {
                    // console.log(n,o,'watch');
                    switch (n.status) {
                        case 0:
                            //登录
                            this.isLogin = true
                            this.regBoxData.isCode = false
                            this.regBoxData.btnText = '登录'
                            this.regBoxData.ciText = '注册'
                            this.regBoxData.infoText = '没有账号'
                            this.passwordLoginHandle()
                            break;
                        case 1:
                            //注册
                            this.isLogin = false
                            this.regBoxData.isCode = true
                            this.regBoxData.btnText = '注册'
                            this.regBoxData.ciText = '登录'
                            this.regBoxData.infoText = '已有账号'
                            break;
                        case 2:
                            this.password = ''
                            this.isLogin = false
                            this.regBoxData.btnText = '找回密码'
                            this.regBoxData.isCode = true
                            break;
                    }
                },
                deep: true
            }
        },
        mounted() {

        },
        methods: {
            forgetPwdHandle() {
                this.regBox.status = 2
            },
            regBoxCloseHandle() {
                this.regBox.show = false
                this.phone = ''
                this.password = ''
                this.code = ''
                this.regBoxData.regSuccess=false
            },
            passwordLoginHandle() {
                this.hList = []
                this.hList[0] = true
                this.regBoxData.isPassword = true
                this.regBoxData.isCode = false
                this.code = ''
                this.password = ''
            },
            codeLoginHandle() {
                this.hList = []
                this.hList[1] = true
                this.regBoxData.isPassword = false
                this.regBoxData.isCode = true
                this.code = ''
                this.password = ''
            },
            regHandle() {
                console.log(this.regBox.status,'this.regBox.status');
                if (this.regBox.status == 0) {
                    //登录
                    this.regBox.status = 1
                    this.regBoxData.isPassword = true
                } else {
                    //注册
                    this.regBox.status = 0
                }
            },
            getCode() {
                if (this.codeMsg == '获取验证码') {
                    if (this.reg.phone.test(this.phone)) {

                        this.$loading()

                        // 接入杜蕾斯
                        this.$durex.ddId().then((ddId) => {
                            window.ddId = ddId
                            //倒计时
                            this.ds = 60;
                            var timer = null;
                            this.codeMsg = (--this.ds) + 's';
                            timer = setInterval(() => {
                                this.codeMsg = (--this.ds) + 's';
                                if (this.ds == 0) {
                                    this.ds = 60;
                                    clearInterval(timer);
                                    this.codeMsg = '获取验证码';
                                }
                            }, 1000)

                            this.sendOTPForH5V2()

                        }).catch((err) => {
                            this.$toast({'msg':err})
                        })

                    } else {
                        this.$toast({ msg: '请输入正确的手机号' })
                    }
                }
            },
            sendOTPForH5V2(v){
                let seqNo = randomString(20)
                let otpType = ''
                switch (this.regBox.status) {
                    case 0:
                        otpType = 0
                        break;
                    case 1:
                        otpType = 1
                        break;
                    case 2:
                        otpType = 2
                        break;
                }
                var nowParam = Object.assign({},{
                    "ddId": window.ddId,
                    "mobile": Rsa(this.phone),
                    "otpType": otpType,
                    seqNo
                },v)

                api.axios({
                    id: 'userAPI.sendOTPForH5V2',
                    param: nowParam
                }).then((res) => {
                    var data = res.data
                    this.$loading.end()
                    if (data.code == '9003') {
                        this.$durex.show({
                            seqNo,
                            scenarioId: 'diandian_smsverifly'
                        }, (val) => {
                            this.ds=60
                            this.sendOTPForH5V2(val)
                        })

                        return
                    }

                    if (data.status == "SUCCESS") {
                        //成功
                        this.isRegister = data.data.isRegister
                    } else {
                        this.$toast({ msg: data.message })
                    }
                }).catch((err) => {
                    this.$toast({ msg: '请求失败' })
                    this.$loading.end()
                })
            },
            druxeBoxWidth(){
                // var dsection=document.getElementsByClassName('durex-section')[0]
                // setTimeout(()=>{
                //     console.log(dsection);
                // },300)
            },
            applyHandle() {
                //校验
                if (!this.reg.phone.test(this.phone)) {
                    this.$toast({ msg: '请输入正确的手机号' })
                    return
                }
                if (this.regBoxData.isCode && !this.reg.code.test(this.code)) {
                    this.$toast({ msg: '请输入正确的验证码' })
                    return
                }
                //密码
                if (this.regBox.status == 1) {
                    //注册校验密码
                    if (this.regBoxData.isPassword && !this.reg.pwd.test(this.password)) {
                        this.$toast({ msg: '密码必须包含数字和英文' })
                        return
                    }
                } else {
                    if (this.regBoxData.isPassword && !this.password) {
                        this.$toast({ msg: '请输入密码' })
                        return
                    }
                }

                var urlParam = this.$route.query
                //请求接口
                this.$loading()
                switch (this.regBox.status) {
                    case 0:
                        //登录
                        if (this.hList[0]) {
                            //密码登录
                            // 接入杜蕾斯
                            this.$durex.ddId().then((ddId) => {
                                window.ddId = ddId
                                this.login({},"2")
                            }).catch((err) => {
                                this.$toast({'msg':err})
                            })
                        } else {
                            //otp登录
                            // 接入杜蕾斯
                            this.$durex.ddId().then((ddId) => {
                                window.ddId = ddId
                                this.login({},"1")
                            }).catch((err) => {
                                this.$toast({'msg':err})
                            })

                        }
                        break;
                    case 1:
                        //注册
                        if (this.isRegister == 0) {
                            //未注册
                            // 接入杜蕾斯
                            this.$durex.ddId().then((ddId) => {
                                window.ddId = ddId
                                this.beginRegister()
                            }).catch((err) => {
                                this.$toast({'msg':err})
                            })

                        } else {
                            //已注册 otp登录
                            // 接入杜蕾斯
                            this.$durex.ddId().then((ddId) => {
                                window.ddId = ddId
                                this.login({},"1")
                            }).catch((err) => {
                                this.$toast({'msg':err})
                            })

                        }
                        break;
                    case 2:
                        //重置密码
                        this.resetLoginPassword()
                        break;
                }
            },
            beginRegister(v){
                let seqNo = randomString(20)
                var nowParam = Object.assign({},{
                    "ddId": window.ddId,
                    "tel": this.phone,
                    "loginName": this.phone,
                    "password": Rsa(md5(this.password)),
                    "verifyCode": this.code,
                    'campaignNo':'diandianguanwang',
                    seqNo
                },v)

                api.axios({
                    id: 'userAPI.register',
                    param: nowParam
                }).then((res) => {
                    var data = res.data
                    this.$loading.end()
                    if (data.code == '9003') {
                        this.$durex.show({
                            seqNo,
                            scenarioId: 'diandian_register'
                        }, (val) => {
                            this.beginRegister(val)
                        })
                        return
                    }
                    if (data.status == "SUCCESS") {
                        //注册成功
                        this.$storage.setItem('user', {
                            'accessKey': data.data.accessKey,
                            'userId': data.data.userId,
                            'thirdUserNo': data.data.thirdUserNo,
                            'phone': this.phone
                        })
                        this.regBox.isUserShow = true
                        this.regBox.phone = this.phone
                        this.regBoxData.regSuccess = true
                    } else {
                        this.$toast({ msg: data.message })
                    }
                }).catch((error) => {
                    this.$loading.end()
                    this.$toast({ msg: error.message })
                })
            },
            login(v,loginType) {
                let seqNo = randomString(20)
                var nowParam = Object.assign({},{
                    "ddId": window.ddId,
                    "loginType": loginType,
                    "mobile": this.phone,
                    "loginPwd": Rsa(md5(this.password)),
                    "verifyCode": this.code,
                    seqNo
                },v)

                api.axios({
                    id: 'userAPI.login',
                    param: nowParam
                }).then((res) => {
                    this.$loading.end()
                    var data = res.data
                    if (data.code == '9003') {
                        this.$durex.show({
                            seqNo,
                            scenarioId: 'diandian_login'
                        }, (val) => {
                            this.login(val,loginType)
                        })
                        return
                    }
                    if (data.status == "SUCCESS") {
                        //登录成功
                        this.$storage.setItem('user', {
                            'accessKey': data.data.accessKey,
                            'userId': data.data.userId,
                            'thirdUserNo': data.data.thirdUserNo,
                            'phone': this.phone
                        })
                        this.regBox.isUserShow = true
                        this.regBox.phone = this.phone
                        this.regBoxData.regSuccess = true
                    } else {
                        this.$toast({ msg: data.message })
                    }
                }).catch((error) => {
                    this.$loading.end()
                    this.$toast({ msg: error.message })
                })
            },
            resetLoginPassword() {
                var regData = {
                    "mobile": this.phone,
                    "password": Rsa(md5(this.password)),
                    "verifyCode": this.code,
                    "passwordType": 0,
                    "operationType": 1
                }
                regData = filterData(regData);
                this.verifyOTP(() => {
                    api.axios({
                        id: 'userAPI.resetLoginPassword',
                        param: regData
                    }).then((res) => {
                        this.$loading.end()
                        var data = res.data
                        if (data.status == "SUCCESS") {
                            //成功
                            this.$toast({ msg: '重置密码成功，请重新登录' })
                            this.regBox.status = 0
                            this.password = ''
                            this.isLogin = true
                            this.regBoxData.isCode = false
                            this.regBoxData.btnText = '登录'
                        } else {
                            this.$toast({ msg: data.message })
                        }
                    }).catch((error) => {
                        this.$loading.end()
                        this.$toast({ msg: error.message })
                    })
                })
            },
            verifyOTP(fn) {
                api.axios({
                    id: 'userAPI.verifyOTP',
                    param: {
                        mobile: this.phone,
                        otpType: 2,
                        verifyCode: this.code
                    }
                }).then((res) => {
                    var data = res.data
                    if (data.status == "SUCCESS") {
                        //成功
                        if (fn) fn.call(this)
                    } else {
                        this.$loading.end()
                        this.$toast({ msg: data.message })
                    }
                }).catch((error) => {
                    this.$loading.end()
                    this.$toast({ msg: error.message })
                })
            },
        }
    }
</script>



// WEBPACK FOOTER //
// index.vue?635a447a